import React from 'react';
import styled from 'styled-components';
import { Dispatch } from 'redux';
import { chatTheme } from '../styles/theme';

import { HideChatBot } from '../store/chatStatus/actions';

const CloseDialogContainer = styled.div`
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 5px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
`;

const CloseDialogMain = styled.div`
  width: 90%;
  height: 100%;
  max-height: 200px;
  max-width: 270px;
  background: #fff;
  border-radius: ${chatTheme.borderRadius};
`;

const CloseDialogBody = styled.div`
  height: 70%;
  pointer-events: none;
  display: flex;
  flex-flow: column;
  padding: 0 5px;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bold;
  color: ${chatTheme.font.primary};
`;

const CloseDialogTitle = styled.div`
  width: 100%;
  padding: 3px 15px;
`;
const CloseDialogDescription = styled.div`
  font-size: 12px;
  padding: 0px 15px;
  margin-top: 5px;
  width: 100%;
  color: ${chatTheme.font.sub};
`;

const CloseDialogFooter = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

type ICloseDialogBtn = {
  backgroundColor: string;
  settingColor: string;
};

const CloseDialogBtn = styled.button<ICloseDialogBtn>`
  border: 1px solid #bfbebe;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  background: ${props => props.backgroundColor};
  color: ${props => props.settingColor};
  border-radius: ${chatTheme.borderRadius};
`;

interface IProps {
  toggleCloseDialog: (e: any) => void;
  btnColor: string;
  dispatch: Dispatch;
}
const CloseDialog: React.FC<IProps> = props => {
  return (
    <CloseDialogContainer id="chatbot-close-dialog">
      <CloseDialogMain
        id="chatbot-close-dialog__main"
        aria-label="close-dialog"
        aria-describedby=""
        aria-modal="true"
        role="dialog"
      >
        <CloseDialogBody>
          <CloseDialogTitle>チャットを非表示にしますか？</CloseDialogTitle>

          <CloseDialogDescription>
            ※再表示する場合はページを再読み込みしてください
          </CloseDialogDescription>
        </CloseDialogBody>
        <CloseDialogFooter id="chatbot-close-dialog__footer">
          <CloseDialogBtn
            id="chatbot-close-dialog__footer__btn--cancel"
            type="button"
            settingColor={chatTheme.font.primary}
            backgroundColor={'#fff'}
            onClick={props.toggleCloseDialog}
          >
            キャンセル
          </CloseDialogBtn>
          <CloseDialogBtn
            id="chatbot-close-dialog__footer__btn--hidden"
            settingColor={'#fff'}
            backgroundColor={props.btnColor}
            onClick={() => props.dispatch(HideChatBot())}
          >
            非表示にする
          </CloseDialogBtn>
        </CloseDialogFooter>
      </CloseDialogMain>
    </CloseDialogContainer>
  );
};

export default CloseDialog;
